import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const TEXT_TYPE_CLASS_PREFIX = 'text-';
export const TEXT_BOLD_CLASS = 'text-bold';
export const TEXT_ITALIC_CLASS = 'text-italic';
export const TEXT_CENTER_CLASS = 'text-center';

export const StyledText = styled(Typography)(({ theme }) => ({
  [`&.${TEXT_TYPE_CLASS_PREFIX}secondarySub`]: {
    color: theme.palette.text.secondary,
    fontSize: 12,
  },
  [`&.${TEXT_TYPE_CLASS_PREFIX}display_large`]: { fontSize: 57 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}display_medium`]: { fontSize: 45 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}display_small`]: { fontSize: 36 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}headline_large`]: { fontSize: 32 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}headline_medium`]: { fontSize: 28 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}headline_small`]: { fontSize: 24 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}title_large`]: { fontSize: 22, fontWeight: 500 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}title_medium`]: { fontSize: 16 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}title_small`]: { fontSize: 14 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}label_large`]: { fontSize: 14 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}label_medium`]: {
    color: alpha(theme.palette.text.primary, 0.6),
    fontSize: 12,
  },
  [`&.${TEXT_TYPE_CLASS_PREFIX}label_small`]: { fontSize: 11 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}label_tiny`]: { fontSize: 10 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}body_large`]: { fontSize: 16 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}body_medium`]: { fontSize: 14 },
  [`&.${TEXT_TYPE_CLASS_PREFIX}body_small`]: { fontSize: 12 },
  [`&.${TEXT_BOLD_CLASS}`]: {
    fontWeight: 'bold',
    transition: 'font-size 0.15s',
  },
  [`&.${TEXT_ITALIC_CLASS}`]: {
    fontStyle: 'italic',
  },
  [`&.${TEXT_CENTER_CLASS}`]: {
    textAlign: 'center',
  },
}));
